import { Spin } from 'antd';
import PredictionMatchCard from './PredictionMatchCard';

const ScorePredictionBoard = ({
  isLoading,
  filteredMatches,
  serverNow,
  sectionLeagueTitle,
  titleBg,
  isLoadingSubmit,
  getLeagueLogo,
  formatRemainingClock,
  onScorePredictClick
}) => {
  return (
    <div className="mt-5 md:mt-6 relative flex justify-center">
      {/* <div className="w-[min(1236px,96vw)] bg-[#F2FBF3] border-[4px] border-[#006719] ring-4 ring-[#006719] rounded-[28px] pt-[16px] px-[16px] max-[980px]:px-[12px] pb-[18px] relative z-[2]"> */}
        {/* <div
          className="mx-auto mb-[12px] mt-[-30px] w-[560px] max-w-[92vw] h-[74px] max-[1024px]:h-[52px] max-[1024px]:mt-[-26px] bg-no-repeat bg-center bg-[length:100%_100%] text-white flex items-center justify-center px-[22px] font-bold text-[25px] leading-none max-[1024px]:text-[18px]"
          style={{ backgroundImage: `url(${titleBg})` }}
        >
          {sectionLeagueTitle}
        </div> */}

        {isLoading ? (
          <div className="py-10 text-center">
            <Spin />
          </div>
        ) : filteredMatches.length === 0 ? (
          <p className="text-center text-[#1f5a32] py-8">Hiện tại không có trận đấu nào để dự đoán.</p>
        ) : (
          <div className="w-[min(1200px,99vw)] border-[2px] border-[#006719] rounded-[12px] p-[10px]">
            <div className="grid grid-cols-1 gap-[8px]">
              {filteredMatches.map((item) => (
                <PredictionMatchCard
                  key={item.matchId}
                  item={item}
                  serverNow={serverNow}
                  isLoadingSubmit={isLoadingSubmit}
                  getLeagueLogo={getLeagueLogo}
                  formatRemainingClock={formatRemainingClock}
                  onScorePredictClick={onScorePredictClick}
                />
              ))}
            </div>
          </div>
        )}
      {/* </div> */}
    </div>
  );
};

export default ScorePredictionBoard;

